import { render, staticRenderFns } from "./ProductInStock.vue?vue&type=template&id=1f64c379&scoped=true&"
import script from "./ProductInStock.vue?vue&type=script&lang=js&"
export * from "./ProductInStock.vue?vue&type=script&lang=js&"
import style0 from "./ProductInStock.vue?vue&type=style&index=0&id=1f64c379&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f64c379",
  null
  
)

export default component.exports